// extracted by mini-css-extract-plugin
export default {"Blogs":"Blogs_Blogs__cap5Y","Blogs__new":"Blogs_Blogs__new__-PWL2","Blogs__table":"Blogs_Blogs__table__gutht"};